import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=8f87f1b2&"
import script from "./submit.vue?vue&type=script&lang=ts&"
export * from "./submit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports